module.exports = __webpack_public_path__ + "MinionPro-Regular.1fbbbec2bb26167fb7b2.eot";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/MinionPro-Regular/MinionPro-Regular.eot
// module id = ../../../../../src/assets/fonts/MinionPro-Regular/MinionPro-Regular.eot
// module chunks = styles